import { Stack, TextField } from "@mui/material";
import type { BigDecimal } from "adl-gen/common";
import type { FormikProps } from "formik";
import { useCallback } from "react";
import type { SetupNewAllocationFormValues } from "../new-purchaser-allocation-page-view";
import { CardWithTitle } from "./card-with-title";

export const MinimumOrderCard = ({
  form,
}: {
  form: FormikProps<SetupNewAllocationFormValues>;
}) => {
  const handleMinimumOrderChange = useCallback(
    (value: BigDecimal) => {
      form.setFieldValue("minimumOrder", value);
    },
    [form],
  );

  const currentValue = form.values.minimumOrder ?? "";

  return (
    <CardWithTitle
      title="Minimum Order Details"
      subtitle="Please specify the minimum order value applicable to orders from the selected purchaser(s)."
      body={
        <Stack spacing={2}>
          <TextField
            label="Minimum Order Value"
            name="minimumOrder"
            required
            type="number"
            value={currentValue.toString()}
            onChange={(e) =>
              handleMinimumOrderChange(e.target.value as BigDecimal)
            }
          />
        </Stack>
      }
    />
  );
};
